export default __webpack_public_path__ + "static/media/xLabs.144bd408.svg";